export default __webpack_public_path__ + "static/media/10.ad3706ed.png";